import { Component } from '@angular/core';

@Component({
  templateUrl: './notfound.page.html',
})
/**
 * Instantiates NotFoundPage template with information
 */
export class NotFoundPage {}
